/* eslint-disable class-methods-use-this */

import { Mark } from 'tiptap'
import { updateMark, markInputRule } from 'tiptap-commands'


export class Alignment extends Mark {
  get name() {
    return 'alignment'
  }

  get defaultOptions() {
    return {
      align: ['left', 'center', 'right', 'justify'],
    }
  }

  get schema() {
    return {
      attrs: {
        align: {
          default: 'left',
        },
      },
      parseDOM: [{
        style: 'text-align',
        getAttrs: (align) => ({ align }),
      }],
      toDOM: (mark) => {
        const align = mark.attrs.align && mark.attrs.align !== 'left'
          ? mark.attrs.align
          : 'inherit'

        return ['span', align !== 'inherit'
          ? { style: `text-align: ${align}; display: block;` }
          : { style: `text-align: ${align};` },
        0]
      },
    }
  }

  commands({ type }) {
    return (attrs) => updateMark(type, attrs)
  }

  inputRules({ type }) {
    return [
      markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
    ]
  }
}
